function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("polygon", {
  fill: "none",
  points: "2195.8,3266.7 2200.9,3266.7 2200.9,3266.7 "
});

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M250,500c-64,0-128-24.4-176.8-73.1C26.1,379.5,0,316.8,0,249.9S26.1,120.2,73.3,73.1 c97.6-97.5,256.2-97.5,353.7,0l0,0c97.4,97.7,97.4,256.5,0,353.8C378.3,475.7,314.1,500,250,500z"
}), React.createElement("g", null, React.createElement("g", null, React.createElement("g", {
  id: "_x30_3_00000162351140143187467850000002446131337172179895_"
}, React.createElement("path", {
  fill: "#004694",
  d: "M423.5,423.5c-95.8,95.8-251.2,95.8-347,0c-95.8-95.8-95.8-251.2,0-347c95.8-95.8,251.2-95.8,347,0 C519.3,172.3,519.3,327.7,423.5,423.5z"
})), React.createElement("g", {
  id: "_x30_3_00000057114787469685931330000018330435311442066582_"
}, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M426.8,250.8c0,99-80.2,179.2-179.2,179.2c-99,0-179.2-80.2-179.2-179.2c0-99,80.2-179.2,179.2-179.2 C346.5,71.6,426.8,151.8,426.8,250.8z"
})), React.createElement("g", {
  id: "_x30_3_00000165236522843819265860000005965685181216641430_"
}, React.createElement("path", {
  fill: "#004694",
  d: "M247.6,424C152,424,74.3,346.3,74.3,250.8c0-95.5,77.7-173.2,173.2-173.2c95.5,0,173.2,77.7,173.2,173.2 C420.8,346.3,343.1,424,247.6,424z M247.6,82.8c-92.7,0-168.1,75.4-168.1,168.1c0,92.7,75.4,168,168.1,168s168.1-75.4,168.1-168 C415.6,158.2,340.2,82.8,247.6,82.8z"
})))), React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M126.4,57.3l7.1-3.9l18.9,16.5l-3.6-24.8l6.9-3.8l4.2,35.9l-5.7,3.1L126.4,57.3z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M164.6,37.9l23.8-8.2l2.1,6.2l-16.9,5.8l2.2,6.4l14.9-5.1l2.1,6.2l-14.9,5.1l2.3,6.6l17.1-5.9l2.1,6.2 l-24,8.2L164.6,37.9z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M199,27.1l15-2.5c4.2-0.7,7.6-0.1,10.1,1.7c2.1,1.5,3.6,3.9,4.1,7l0,0.1c0.9,5.3-1.4,9.1-5.3,11.4l10,10.4 l-8.5,1.4l-8.8-9.3l-5.7,1l1.8,10.5l-7.2,1.2L199,27.1z M216.2,40.6c3.5-0.6,5.2-2.8,4.8-5.6l0-0.1c-0.5-3.1-2.9-4.3-6.5-3.7 l-7.2,1.2l1.6,9.4L216.2,40.6z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M236.5,22.1l7.3-0.3l1.4,33.3l-7.3,0.3L236.5,22.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M255.1,21.5l25.3,1.8l-0.5,6.6l-18-1.3l-0.5,7.1l15.9,1.1l-0.5,6.6l-15.9-1.1L260,55.3l-7.3-0.5L255.1,21.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M289.3,25.1l7.2,1.4l-6.2,32.7l-7.2-1.4L289.3,25.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M307.7,28.8l24,7.6l-2,6.2l-17-5.4l-2,6.4l15,4.7l-2,6.2l-15-4.7l-2.1,6.7l17.2,5.5l-2,6.2l-24.2-7.7 L307.7,28.8z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M342,40.5l11.5,6c9.3,4.8,12.4,14.5,8.1,22.9l0,0.1c-4.3,8.3-14.1,11.5-23.4,6.6l-11.5-6L342,40.5z  M345.4,49.7l-9.2,17.8l5,2.6c5.3,2.8,10.8,1,13.5-4.2l0-0.1c2.7-5.2,1-10.8-4.3-13.5L345.4,49.7z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#FFFFFF",
  d: "M125.2,437.1l6.4-2.3c1.3,3.7,3.3,6.6,6.5,8.5c2.6,1.5,4.8,1.4,5.7-0.3l0-0.1c0.9-1.6,0.4-3-3.7-7 c-4.9-4.9-7.7-8.7-4.4-14.4l0-0.1c3.1-5.2,9.3-6.2,15.1-2.8c4.2,2.5,7,5.9,8.5,9.9l-6.1,2.8c-1.5-3.3-3.4-5.8-5.8-7.2 c-2.4-1.4-4.3-1.1-5.2,0.3l0,0.1c-1.1,1.9-0.2,3.2,4,7.4c4.9,4.9,7,9,4.1,14l0,0.1c-3.3,5.7-9.6,6.4-15.8,2.7 C130.3,446.3,126.8,442.2,125.2,437.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M158.9,445.4l6.9-17.8l6.8,2.6l-6.8,17.6c-2,5.1-0.4,8.7,3.7,10.3c4.2,1.6,7.7,0.1,9.6-4.9l6.9-17.8l6.8,2.6 l-6.8,17.5c-3.6,9.4-10.7,12-19.1,8.7C158.6,461.2,155.3,454.5,158.9,445.4z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M198.1,439.4l13.3,2.8c7.8,1.6,11.5,7.2,10.1,13.9l0,0.1c-1.6,7.5-8.3,10.2-15.6,8.7l-5.5-1.1l-2,9.8 l-7.2-1.5L198.1,439.4z M207.5,458.6c3.6,0.7,6.1-1,6.7-3.8l0-0.1c0.7-3.2-1.2-5.4-4.8-6.2l-5.5-1.2l-2.1,10L207.5,458.6z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M227.4,445.1l13.6,0.7c7.9,0.4,12.5,5.4,12.1,12.2l0,0.1c-0.4,7.7-6.6,11.4-14.1,11l-5.6-0.3l-0.5,10 l-7.3-0.4L227.4,445.1z M239.6,462.5c3.7,0.2,5.9-1.9,6.1-4.7l0-0.1c0.2-3.3-2-5.2-5.7-5.4l-5.7-0.3l-0.5,10.2L239.6,462.5z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M257.3,446.1l7.3-0.7L267,472l16.5-1.5l0.6,6.6l-23.9,2.2L257.3,446.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M285.5,442.8l7.2-1.5l6.6,32.7l-7.2,1.5L285.5,442.8z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M299.5,440.1l23.9-7.8l2,6.2l-17,5.5l2.1,6.4l14.9-4.9l2,6.2l-14.9,4.9l2.2,6.7l17.2-5.6l2,6.2l-24.1,7.9 L299.5,440.1z"
}), React.createElement("path", {
  fill: "#FFFFFF",
  d: "M327.7,430.5l13.5-7c3.8-1.9,7.2-2.4,10.2-1.4c2.5,0.8,4.6,2.7,6,5.5l0,0.1c2.5,4.8,1.4,9.1-1.6,12.5 l12.7,6.9l-7.6,3.9l-11.2-6.2l-5.1,2.6l4.9,9.5l-6.5,3.4L327.7,430.5z M348.3,438.1c3.2-1.6,4.1-4.3,2.8-6.8l0-0.1 c-1.4-2.8-4.1-3.2-7.3-1.6l-6.5,3.3l4.4,8.5L348.3,438.1z"
})), React.createElement("g", null, React.createElement("path", {
  fill: "#004694",
  d: "M105.4,253.1v-0.2c0-19.4,14.8-34.6,35-34.6c13.6,0,22.4,5.7,28.3,13.8l-13.9,10.8c-3.8-4.7-8.2-7.8-14.6-7.8 c-9.3,0-15.9,8-15.9,17.7v0.2c0,10,6.6,17.8,15.9,17.8c6.9,0,11-3.2,15-8.1l13.9,9.9c-6.3,8.7-14.7,15-29.4,15 C120.7,287.5,105.4,273,105.4,253.1L105.4,253.1z"
}), React.createElement("polygon", {
  fill: "#004694",
  points: "174.5,219.4 193.5,219.4 193.5,244.5 217.3,244.5 217.3,219.4 235.9,219.4 235.9,286.5 217.3,286.5 217.3,261 193.1,261 193.1,286.5 174.5,286.5 174.5,219.4  "
}), React.createElement("polygon", {
  fill: "#004694",
  points: "174.5,219.4 193.5,219.4 193.5,244.5 217.3,244.5 217.3,219.4 235.9,219.4 235.9,286.5 217.3,286.5 217.3,261 193.1,261 193.1,286.5 174.5,286.5 174.5,219.4  "
}), React.createElement("path", {
  fill: "#004694",
  d: "M316.1,276.5l10.3-12.3c6.6,5.2,13.9,8,21.6,8c5,0,7.7-1.7,7.7-4.6v-0.3c0-2.9-2.2-4.3-11.4-6.5 c-14.3-3.3-25.2-7.3-25.2-20.9v-0.4c0-12.3,9.7-21.2,25.6-21.2c11.2,0,20,3,27.2,8.8l-9.2,12.9c-6-4.3-12.7-6.5-18.5-6.5 c-4.4,0-6.6,1.8-6.6,4.3v0.3c0,3.1,2.3,4.4,11.7,6.5c15.3,3.4,24.9,8.3,24.9,20.9v0.3c0,13.6-10.7,21.7-26.9,21.7 C335.5,287.5,324.4,283.8,316.1,276.5L316.1,276.5z"
}), React.createElement("path", {
  fill: "#004694",
  d: "M369.6,241L369.6,241c0-4.7,3.7-8.5,8.4-8.5c4.8,0,8.4,3.8,8.4,8.4v0c0,4.6-3.7,8.5-8.4,8.5 C373.3,249.4,369.6,245.6,369.6,241L369.6,241z M384.4,240.9L384.4,240.9c0-3.6-2.7-6.5-6.4-6.5c-3.6,0-6.4,2.9-6.4,6.5v0 c0,3.5,2.7,6.4,6.4,6.4C381.7,247.4,384.4,244.4,384.4,240.9L384.4,240.9z M374.5,236.7h3.9c2.1,0,3.5,0.9,3.5,2.7 c0,1.2-0.6,2-1.6,2.5l1.9,2.7h-3.1l-1.4-2.1H377v2.1h-2.5V236.7L374.5,236.7z M378.2,240.4c0.7,0,1.1-0.3,1.1-0.8 c0-0.5-0.4-0.8-1-0.8H377v1.6H378.2L378.2,240.4z"
}), React.createElement("path", {
  fill: "#004694",
  d: "M240.6,286.5h19.7l4.7-11.9h25.7l4.7,11.9h20.1l-28.4-67.1h-18.3L240.6,286.5L240.6,286.5z M285.3,259.7 h-15.1l7.6-19L285.3,259.7L285.3,259.7z"
})));

var SvgChasVerifiedSupplier = function SvgChasVerifiedSupplier(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "CHAS_Verified_Supplier",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChasVerifiedSupplier, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CHAS Verified Supplier.2985f150.svg";
export { ForwardRef as ReactComponent };